<div class="rendition-delete-draft-container">
  <p>
    ¿Está seguro que desea eliminar el borrador
    <b>“{{ this.address }}”</b>? Esta acción es irreversible.
  </p>
</div>
